import React, { useState, useEffect } from "react";
import Loading from './Loading';
import Modal from 'react-bootstrap/Modal';
import GraficaEjes from './GraficaEjes';
import GraficaRadar from './GraficaRadar';
import GraficaBrechas from './GraficaBrechas';
import TablaBrechas from './TablaBrechas';
import TablaBrechasInver from './TablaBrechasInver';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import './App.css';
import Ejes from './Ejes';
import logoUNFPA from "./logoUNFPA.png"
import logoTriage from "./logoTriage.png"
import info from './info.png';
import TablaParalelas from "./TablaParalelas";
import LetreroBrechas from "./LetreroBrechas";


function App({ passRef, extGrafica }) {

  var datosIniciales = require('./direcciones.json');

  // Token
  const TOKEN = datosIniciales["llaveArc"];

  // Year range
  const years = datosIniciales["anios"];

  // Addresses
  const arc_online = datosIniciales["url"];
  const addresses = datosIniciales["direcciones"];

  // Info inicial (de donde se obtienen listados de municipiosm detos y regiones PDET)
  const infoInicialDept = datosIniciales["infoInicialDept"];
  const infoInicialMun = datosIniciales["infoInicialMun"];
  const infoInicialPDET = datosIniciales["infoInicialPDET"];

  // opciones de graficas
  const optionsG = [
    { value: 'paralelos', label: 'Coordenadas paralelas' },
    //{ value: 'radar', label: 'Radar' },
    { value: 'brechas', label: 'Brechas' }
  ];

  // Inicializacion de los estados

  let initialState = { deptos: [], data: {}, addresses: addresses }; // cache de datos 

  let [state, setState] = useState(initialState); // cache de datos 
  let [axes, setAxes] = useState({ axes: [], ejes: [], regiones: [], ejeBrechas: undefined, regionBrechas: undefined });
  let [grafica, setGrafica] = useState({ tipo: optionsG[0]["value"], tooltip: false })
  let [ejesGraficos, setEjesGraficos] = useState({ ejes: [], series: [], limites: [], ejesVisibles: [] });
  let [ejesGraficoBrechas, setEjesGraficoBrechas] = useState({ ejes: [], scatter: [], plot: [] })
  let [showInfo, setShowInfo] = useState(false);
  let [inverTabla, setInverTabla] = useState(true);
  const [fuente, setFuente] = useState("");

  const handleCloseInfo = () => setShowInfo(false);
  const handleShowInfo = e => {
    e.preventDefault();
    setShowInfo(true);
  }

  const [darkMode, setDarkMode] = useState(false);

  //
  useEffect(() => {

    // Add listener to update styles
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => { setDarkMode(e.matches) });

    // Setup dark/light mode for the first time
    setDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches)
    fetchInitialState()
    // Remove listener
    return () => {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', () => {
      });
    }
  }, [])

  useEffect(() => {
    setGrafica({ tipo: extGrafica, tooltip: false });
  }, [extGrafica])

  // Query
  function build_query(sn, bd, where = { key: 1, value: 1 }, local_address) {
    let response = "query?where="
    let fieldReplace = ""
    if (!Array.isArray(where)) {
      where = [where]
    }
    if (sn == "bd_16_pdet") {
      return 'https://rmmback.amartinez1224.repl.co/rmm/pdet/' + where[0]['value']
    }
    if (sn == "bd_16_dept") {
      return 'https://rmmback.amartinez1224.repl.co/rmm/dept/' + where[0]['value']
    }
    if (sn == "bd_16_mun") {
      return 'https://rmmback.amartinez1224.repl.co/rmm/mun/' + where[1]['value'] + '/' + where[0]['value']
    }
    if (sn == "bd_21_pdet") {
      return 'https://rmmback.amartinez1224.repl.co/vbg/pdet/' + where[0]['value']
    }
    if (sn == "bd_21_dept") {
      return 'https://rmmback.amartinez1224.repl.co/vbg/dept/' + where[0]['value']
    }
    if (sn == "bd_21_mun") {
      return 'https://rmmback.amartinez1224.repl.co/vbg/mun/' + where[1]['value'] + '/' + where[0]['value']
    }
    if (bd == "BD_16_RMM" || bd == "BD_12_IMP_Fem") {
      where = where.map(item => {
        if (item["key"] == "Anio") {
          item["key"] = "Ano"
        }
        return item
      })
    }
    if (sn == "bd_11_dept" || sn == "bd_28_mun" || sn == "bd_28_pdet") {
      where = where.filter(item => item["key"] != "Anio")
      if (where.length < 1) {
        where = [{ key: 1, value: 1 }]
      }
    }
    if (sn == "bd_20_dept") {
      fieldReplace = "%2C+percent_women_15_49_afiliated_s+AS+percent_women_15_49"
    }
    if (sn == "bd_28_mun" || sn == "bd_28_pdet") {
      fieldReplace = "%2Crate_illiteracy_2018+AS+rate_illiteracy"
    }
    if (bd == "BD_21_VBG") {
      fieldReplace = "%2Crate_total_vbg_2014+AS+rate_total_vbg"
    }
    where.forEach(item => { response = response + item["key"] + "%3D" + ((typeof item["value"] === 'string') ? "%27" + item["value"] + "%27" : item["value"]) + "+AND+" })
    return arc_online + local_address + response.slice(0, -5) + "&objectIds=&time=&resultType=none&outFields=*" + fieldReplace + "&returnHiddenFields=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&sqlFormat=none&f=pjson&token=" + TOKEN
  }

  function fetchInitialState() {

    // fetch department data
    let promises = []

    let itemDept = addresses.find(address => address.n == infoInicialDept && address.l == "dept")
    promises.push(fetch(build_query(itemDept.sn, itemDept.n, { key: "Anio", value: 2019 }, itemDept.a))
      .then(r => r.json())
      .then(d => {
        return { data: d.features, item: { ...itemDept } }
      })
      .catch(e => {
        return { data: [], item: { ...itemDept } }
      })
    )

    let itemMun = addresses.find(address => address.n == infoInicialMun && address.l == "mun")
    promises.push(fetch(build_query(itemMun.sn, itemMun.n, { key: "Anio", value: 2019 }, itemMun.a))
      .then(r => r.json())
      .then(d => {
        return { data: d.features, item: { ...itemMun } }
      })
      .catch(e => {
        return { data: [], item: { ...itemMun } }
      })
    )

    let itemPDET = addresses.find(address => address.n == infoInicialPDET && address.l == "PDET")
    promises.push(fetch(build_query(itemPDET.sn, itemPDET.n, { key: "Anio", value: 2019 }, itemPDET.a))
      .then(r => r.json())
      .then(d => {
        return { data: d.features, item: { ...itemPDET } }
      })
      .catch(e => {
        return { data: [], item: { ...itemPDET } }
      })
    )

    /*
  addresses.filter(item => item.l == "dept").forEach(item => {
    years.forEach(year => {
      promises.push(fetch(build_query({ key: "Anio", value: year },item.a))
        .then(r => r.json())
        .then(d => {
          return { data: d.features, item: { ...item, year: year } }
        })
        .catch(e => {
          return { data: [], item: { ...item, year: year } }
        })
      )
    })
  })
  */

    Promise.all(promises)
      .then(ans => {

        // set data for departments
        let newState = { data: {}, dataPDET: {} }

        // get department list
        let deptos = []
        let departamentos = []
        ans.find(answ => answ.item.n == infoInicialDept && answ.item.l == "dept").data.forEach(feature => {
          deptos.push(feature.attributes.department)
          departamentos.push({ nombre: feature.attributes.department, divipola: feature.attributes.divipola })
        })
        addresses.filter(address => address.l == "dept").forEach(address => {
          if (!(address.n in newState.data)) {
            let deptosDict = {}
            deptos.forEach(depto => {
              let yearsDict = {}
              years.forEach(year => {
                yearsDict[year] = { depto: false, mun: false }
              })
              deptosDict[depto] = { ...yearsDict }
            })
            newState.data[address.n] = { ...deptosDict }
          }
        })

        let PDET = []
        ans.find(answ => answ.item.n == infoInicialPDET && answ.item.l == "PDET").data.forEach((feature, index, array) => {
          PDET.push({ nombre: feature.attributes.department, divipola: feature.attributes.divipola })
        })
        addresses.filter(address => address.l == "PDET").forEach(address => {
          if (!(address.n in newState.dataPDET)) {
            let deptosDict = {}
            PDET.forEach(depto => {
              let yearsDict = {}
              years.forEach(year => {
                yearsDict[year] = false
              })
              deptosDict[depto.nombre] = { ...yearsDict }
            })
            newState.dataPDET[address.n] = { ...deptosDict }
          }
        })



        newState = {
          ...newState, deptos: deptos.sort(), PDET: PDET, departamentos: departamentos.sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            return 0;
          })
        }

        let promises = []
        let itemMun = addresses.find(address => address.n == infoInicialMun && address.l == "mun")
        deptos.forEach(depto => {
          promises.push(fetch(build_query(itemMun.sn, itemMun.n, [{ key: "Anio", value: 2019 }, { key: "department", value: depto }], itemMun.a))
            .then(r => r.json())
            .then(d => {
              return { data: d.features, depto: depto }
            })
            .catch(e => {
              return { data: [], depto: depto }
            })
          )
        })

        Promise.all(promises)
          .then(ans => {
            let municipios = {}
            ans.forEach(answ => {
              let muns = []
              if (answ.data) {
                answ.data.forEach(item => {
                  muns.push({ divipola: item.attributes.divipola, nombre: item.attributes.municipality })
                })
                municipios[answ.depto] = muns
              }
            })
            newState = { ...newState, municipios: municipios }
            setState({ ...state, ...newState })
          })
      })
  }

  function fetchPDETData(Anio, BD) {
    let item = addresses.find(address => address.n == BD && address.l == "PDET")
    fetch(build_query(item.sn, item.n, { key: "Anio", value: Anio }, item.a))
      .then(r => r.json())
      .then(d => {
        let newData = state.dataPDET
        state.PDET.forEach(depto => {
          newData[item.n][depto.nombre][Anio] = d.features.filter(item => item.attributes.department == depto.nombre)
          if (!newData[item.n][depto.nombre][Anio]) {
            newData[item.n][depto.nombre][Anio] = []
          }
          else {
            newData[item.n][depto.nombre][Anio] = newData[item.n][depto.nombre][Anio].map(item => {
              let fields = addresses.find(address => address.n == BD && address.l == "dept").fields
              fields.forEach(field => {
                item.attributes[field.value] = item.attributes[field.value] ? item.attributes[field.value] * field.calc : item.attributes[field.value]
              })
              return item
            })
          }
        })
        setState({ ...state, dataPDET: newData })
      })
      .catch(e => {
        let newData = state.dataPDET
        state.PDET.forEach(depto => {
          newData[item.n][depto.nombre][Anio] = []
        })
        setState({ ...state, dataPDET: newData })
      })
  }

  function fetchDeptData(Anio, BD) {
    let item = addresses.find(address => address.n == BD && address.l == "dept")
    fetch(build_query(item.sn, item.n, { key: "Anio", value: Anio }, item.a))
      .then(r => r.json())
      .then(d => {
        let newData = state.data
        state.departamentos.forEach(depto => {
          newData[item.n][depto.nombre][Anio]["depto"] = d.features.filter(item => item.attributes.department == depto.nombre)
          if (!newData[item.n][depto.nombre][Anio]["depto"]) {
            newData[item.n][depto.nombre][Anio]["depto"] = []
          }
          else {
            newData[item.n][depto.nombre][Anio]["depto"] = newData[item.n][depto.nombre][Anio]["depto"].map(iteml => {
              let fields = item.fields
              fields.forEach(field => {
                iteml.attributes[field.value] = iteml.attributes[field.value] ? iteml.attributes[field.value] * field.calc : iteml.attributes[field.value]
              })
              return iteml
            })
          }
        })
        setState({ ...state, data: newData })
      })
      .catch(e => {
        let newData = state.data
        state.departamentos.forEach(depto => {
          newData[item.n][depto.nombre][Anio]["depto"] = []
        })
        setState({ ...state, data: newData })
      })
  }

  function fetchMunData(depto, Anio, BD) {
    let item = addresses.find(address => address.n == BD && address.l == "mun")
    fetch(build_query(item.sn, item.n, [{ key: "department", value: depto }, { key: "Anio", value: Anio }], item.a))
      .then(r => r.json())
      .then(d => {
        let newData = state.data
        newData[item.n][depto][Anio]["mun"] = d.features
        if (!newData[item.n][depto][Anio]["mun"]) {
          newData[item.n][depto][Anio]["mun"] = []
        }
        else {
          newData[item.n][depto][Anio]["mun"] = newData[item.n][depto][Anio]["mun"].map(item => {
            let fields = addresses.find(address => address.n == BD && address.l == "dept").fields
            fields.forEach(field => {
              item.attributes[field.value] = item.attributes[field.value] ? item.attributes[field.value] * field.calc : item.attributes[field.value]
            })
            return item
          })
        }
        setState({ ...state, data: newData })
      })
      .catch(e => {
        let newData = state.data
        newData[item.n][depto][Anio]["mun"] = []
        setState({ ...state, data: newData })
      })
  }

  function updateAxes(newAxes, last, type, data, depto) {
    setAxes({ last: last, data: data, type: type, axes: newAxes, depto: depto })
  }

  function actualizarEjes(nuevosEjes, nuevasRegiones) {
    setAxes({ ...axes, ejes: nuevosEjes, regiones: nuevasRegiones })
  }

  function actualizarEjeBrechas(nuevoEje) {
    setAxes({ ...axes, ejeBrechas: nuevoEje })
  }

  function actualizarRegionBrechas(nuevaRegion) {
    setAxes({ ...axes, regionBrechas: nuevaRegion })
  }

  function actualizarFullEjes(nuevosEjes, nuevasRegiones, nuevoEje, nuevaRegion) {
    setAxes({ ...axes, ejes: nuevosEjes, regiones: nuevasRegiones, ejeBrechas: nuevoEje, regionBrechas: nuevaRegion })
  }

  function changeGrafica(newVal) {
    if (newVal["value"] == "paralelos") {
      setFuente("Multiples fuentes.")
    }
    setGrafica({ ...grafica, tipo: newVal["value"] })
  }

  function graficaSeleccionada() {
    if (grafica.tipo == "paralelos") {
      return <GraficaEjes data={ejesGraficos} tooltip={grafica.tooltip} darkMode={darkMode}></GraficaEjes>
    }
    else if (grafica.tipo == "radar") {
      return <GraficaRadar data={ejesGraficos} tooltip={grafica.tooltip} darkMode={darkMode}></GraficaRadar>
    }
    else if (grafica.tipo == "brechas") {
      return <GraficaBrechas data={ejesGraficoBrechas} tooltip={grafica.tooltip} darkMode={darkMode}></GraficaBrechas>
    }
  }

  function changeTooltip(newVal) {
    if (newVal.target.value == "true") {
      setGrafica({ ...grafica, tooltip: true })
    }
    else {
      setGrafica({ ...grafica, tooltip: false })
    }
  }

  function invertirTabla() {
    setInverTabla(!inverTabla)
  }

  function showTablaBrechas() {
    if (inverTabla) {
      return <TablaBrechasInver ejes={ejesGraficoBrechas.ejes} infoEje={axes.ejeBrechas} infoReg={axes.regionBrechas} invertir={invertirTabla} darkMode={darkMode} />
    }
    else {
      return <TablaBrechas ejes={ejesGraficoBrechas.ejes} infoEje={axes.ejeBrechas} infoReg={axes.regionBrechas} invertir={invertirTabla} darkMode={darkMode} />
    }
  }

  function showTabla() {
    if (grafica.tipo == "brechas" && ejesGraficoBrechas.ejes.length > 0 && ejesGraficoBrechas.plot.length > 0) {
      return (<>
        <div className="row align-items-start">
          <div className="col-md-12 col-sm-12 col-xs-12">
            {showTablaBrechas()}
          </div>
        </div>

        <LetreroBrechas ejes={ejesGraficoBrechas.ejes} infoEje={axes.ejeBrechas} infoReg={axes.regionBrechas} />
        <br />
      </>
      )
    }
    else if (grafica.tipo == "paralelos" && ejesGraficos.ejes.length > 0 && ejesGraficos.series.length > 0) {
      return <TablaParalelas ejes={ejesGraficos.ejes} series={ejesGraficos.series} ejesVisibles={ejesGraficos.ejesVisibles} darkMode={darkMode} />
    }
  }

  function showTooltipOptions() {
    if (grafica.tipo != "radar") {
      return (<>
        <div className="col-md-3 col-sm-6 col-xs-8">
          <strong>Mostrar etiquetas grupales:</strong> <br />
          <Form.Check
            inline
            value={true}
            type={"radio"}
            id={"default-radio"}
            label={"Sí"}
            name="tootltips"
            onChange={changeTooltip}
            checked={grafica.tooltip}
          /><Form.Check
            inline
            value={false}
            type={"radio"}
            id={"default-radio"}
            label={"No"}
            name="tootltips"
            onChange={changeTooltip}
            checked={!grafica.tooltip}
          />
        </div>
      </>
      )
    }
  }

  function showGraficaOptions() {
    return (
      <>
        <strong>Tipo de gráfica:</strong>
        <Select
          options={optionsG}
          closeMenuOnSelect={true}
          onChange={changeGrafica}
          defaultValue={optionsG[0]}
          theme={darkMode ? (theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#646a70',
              primary25: '#444a50',
              primary50: '#545a60',
              neutral0: '#343a40',
              neutral80: '#fff',
              neutral100: '#fff',
            },
          }) : null}
        />
      </>
    );
  }

  function showModal() {
    if (grafica.tipo == "paralelos") {
      return (<Modal show={showInfo} onHide={handleCloseInfo}>
        <Modal.Body>
          <h5>Visor Multivariable - Triage Poblacional</h5>
          El visor multivariable (Triage Poblacional) es una herramienta complementaria al Triage Poblacional que permite hacer un análisis comparativo, correlativo, desagregado y temporal entre diferentes variables y regiones. Esta nueva herramienta les permite a las autoridades locales, a los formuladores de políticas públicas y a la ciudadanía en general, tejer historias visuales que brindan información relevante de sus poblaciones.
          <hr />
          <h6> ¿Qué es un gráfico de coordenadas paralelas? </h6>
          Las coordenadas paralelas son una técnica de visualización utilizada para trazar elementos de datos individuales a través de muchas variables/indicadores. Cada una de las variables corresponde a un eje vertical y cada elemento de datos se muestra como una serie de puntos conectados a lo largo de la variable/ejes.
          <hr />
          <h6>¿Como agregar/modificar/eliminar variables?</h6>
          Para agregar una nueva variable se debe seleccionar en el menú superior izquierdo la opción ‘Variables’ y posteriormente seleccionar la opción agregar en la parte inferior izquierda. Una vez agregada se puede seleccionar en la lista la variable para ser modificada o eliminada.
          <hr />
          <h6>¿Como agregar/modificar/eliminar regiones?</h6>
          Para agregar una nueva región se debe seleccionar en el menú superior izquierdo la opción ‘Regiones’ y posteriormente seleccionar la opción agregar en la parte inferior izquierda. Una vez agregada se puede seleccionar en la lista la región para ser modificada o eliminada.
          <hr />
          Descargue una guía avanzada haciendo <a href='https://dashboard-co-unfpa.s3.amazonaws.com/guia_visor_correlacional.pdf' target="_blank" download rel="noreferrer"><strong><u>clic aquí</u></strong></a>.

        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" id="btnInfo" onClick={handleCloseInfo}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>)
    }
    else if (grafica.tipo == "brechas") {
      return (<Modal show={showInfo} onHide={handleCloseInfo}>
        <Modal.Body>
          <h5>Visor Multivariable - Triage Poblacional</h5>
          El visor multivariable (Triage Poblacional) es una herramienta complementaria al Triage Poblacional que permite hacer un análisis comparativo, correlativo, desagregado y temporal entre diferentes variables y regiones. Esta nueva herramienta les permite a las autoridades locales, a los formuladores de políticas públicas y a la ciudadanía en general, tejer historias visuales que brindan información relevante de sus poblaciones.
          <hr />
          <h6> ¿Qué es un gráfico de brechas? </h6>
          El gráfico de brechas permite visualizar los valores para múltiples desagregaciones de una misma variable/indicador en una región específica. Las líneas horizontales son valores de referencia constantes y los puntos de cada eje son los valores de las distintas desagregaciones.
          <hr />
          <h6>¿Como modificar la variable mostrada?</h6>
          Para modificar la variable seleccionada, utilice el menú de la izquierda de la pantalla donde puede seleccionar una nueva variable y el año deseado.
          <hr />
          <h6>¿Como modificar la region a desagregar?</h6>
          Para modificar la región seleccionada, utilice el menú de la izquierda de la pantalla, donde puede seleccionar una nueva región y, si es necesario, un municipio. La opción "--" indica que no desea seleccionar ningún municipio.
          <hr />
          Descargue una guía avanzada haciendo <a href='https://dashboard-co-unfpa.s3.amazonaws.com/guia_visor_correlacional.pdf' target="_blank" download rel="noreferrer"><strong><u>clic aquí</u></strong></a>.

        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" id="btnInfo" onClick={handleCloseInfo}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>)
    }
  }

  function inicio() {
    if (state.deptos.length > 0) {
      return (
        <div className="container-fluid" >
          {showModal()}
          <div className="row align-items-start">
            <div className="col-md-9 col-sm-8 col-xs-12 order-md-last order-sm-last">
              <div className="row align-items-start">
                <form>
                  <div className="form-group row px-3">
                  <div className="col-md-4 col-sm-6 col-xs-8">
                    {/*showGraficaOptions()*/}
                    </div>
                    {/*showTooltipOptions()*/}
                    <div className="col-md-4 col-sm-3 col-xs-6 text-center">
                      <button className="btn btn-default" id="btnInfo" onClick={handleShowInfo} style={{ margin: "10px" }}>
                        <div><img src={info} className="rounded mx-auto  info-icon" alt="..."></img> Información</div>
                      </button>
                    </div>
                    <div className="col-md-4 col-sm-3 col-xs-6 text-end">
                      <sub>{fuente}</sub>
                    </div>
                  </div>
                </form>
                <br />

              </div>
              <div id="containerGrafica">
                <div className="row align-items-start" id="viewDiv">
                  {graficaSeleccionada()}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-12 order-md-first order-sm-first">
              <Ejes ejes={axes} estado={state} actualizarEjes={actualizarEjes} actualizarFullEjes={actualizarFullEjes} actualizarEjeBrechas={actualizarEjeBrechas} actualizarRegionBrechas={actualizarRegionBrechas} updateData={{ fetchMunData, fetchDeptData, fetchPDETData }} direcciones={addresses} grafica={setEjesGraficos} graficaBrechas={setEjesGraficoBrechas} ejesBrechas={ejesGraficoBrechas} tipoGrafica={grafica.tipo} setFuente={setFuente} darkMode={darkMode}></Ejes>
            </div>

          </div>
          <br />
          {showTabla()}
        </div>
      )

    }
    else {
      return <Loading></Loading>
    }

  }


  return (
    <div className="App" ref={passRef}>
      {inicio()}
    </div>
  );
}

export default App;
